import React, { useState, useMemo } from 'react';
import TeamSaveControls from './TeamSaveControls';

export default function TeamFilterModal({ teams, visibleTeams, toggleTeamVisibility, onClose, userId }) {
  const [search, setSearch] = useState('');
  const [msg, setMsg] = useState('');
  const isMobile = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 900px)').matches;

  // Remove 'Anderen' from selectable teams entirely
  const availableTeams = useMemo(
    () => teams.filter(t => (t || '').trim().toLowerCase() !== 'anderen'),
    [teams]
  );

  const filtered = useMemo(
    () => availableTeams.filter(t => t.toLowerCase().includes(search.toLowerCase())),
    [availableTeams, search]
  );

  const allSelected = filtered.every(t => visibleTeams.has(t));

  const selectAllFiltered = () => {
    if (allSelected) {
      // remove all filtered from set
      const newSet = new Set(visibleTeams);
      filtered.forEach(t => newSet.delete(t));
      // if empty, default behaviour shows all teams -> keep empty
      onBulkChange(newSet);
    } else {
      const newSet = new Set(visibleTeams);
      filtered.forEach(t => newSet.add(t));
      onBulkChange(newSet);
    }
  };

  const clearAll = () => onBulkChange(new Set());

  const onBulkChange = (setVal) => {
    // propagate by triggering state update pattern (hook lives in parent)
    // We'll rebuild set by toggling difference
    const current = new Set(visibleTeams);
    // Determine removals
    availableTeams.forEach(t => {
      const shouldBe = setVal.has(t);
      const is = current.has(t);
      if (shouldBe !== is) toggleTeamVisibility(t);
    });
  };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.3)', zIndex:12000, display:'flex', justifyContent:'center', alignItems:'center' }} onClick={onClose}>
      <div style={{ background:'#fff', width:isMobile? '100vw':'min(640px,90vw)', maxHeight:isMobile? '100vh':'80vh', height:isMobile? '100vh':'auto', borderRadius:isMobile? 0: '0.75rem', padding:'1.25rem 1.25rem 0.75rem', display:'flex', flexDirection:'column', boxSizing:'border-box', position:'relative' }} onClick={e => e.stopPropagation()}>
        <h3 style={{ margin:'0 0 .75rem', fontSize:'1.25rem', fontWeight:700, color:'#057fa2' }}>Filter Teams</h3>
        {!isMobile && (
          <>
            <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Zoek teams..." style={{ width:'100%', padding:'.65rem .75rem', border:'1.5px solid #cbd5e1', borderRadius:'.5rem', fontSize:'.9rem', marginBottom:'.75rem' }} />
            <div style={{ display:'flex', gap:'.5rem', flexWrap:'wrap', marginBottom:'.75rem' }}>
              <button onClick={selectAllFiltered} style={{ background:'#057fa2', color:'#fff', border:'none', borderRadius:'.4rem', padding:'.45rem .8rem', fontSize:'.7rem', fontWeight:600, cursor:'pointer' }}>{allSelected? 'Deselecteer gefilterde':'Selecteer gefilterde'}</button>
              <button onClick={clearAll} style={{ background:'#6b7280', color:'#fff', border:'none', borderRadius:'.4rem', padding:'.45rem .8rem', fontSize:'.7rem', fontWeight:600, cursor:'pointer' }}>Reset (alles tonen)</button>
              <TeamSaveControls userId={userId} selectedTeams={visibleTeams} onSaved={(t)=>{ setMsg(t); setTimeout(()=>setMsg(''), 3000); }} className="tq-filter__btn" />
              <button onClick={onClose} style={{ background:'#fff', color:'#057fa2', border:'1px solid #057fa2', borderRadius:'.4rem', padding:'.45rem .8rem', fontSize:'.7rem', fontWeight:600, cursor:'pointer' }}>Sluiten</button>
            </div>
          </>
        )}
        {!!msg && <div style={{ marginBottom:'.5rem', padding:'.5rem', background: msg.includes('Error') ? '#e74c3c' : '#2ecc71', color:'#fff', borderRadius:'.5rem', fontWeight:600, textAlign:'center', fontSize:'.85rem' }}>{msg}</div>}
        <div style={{ overflowY:'auto', flex:1, border:'1px solid #e2e8f0', borderRadius:'.5rem', padding:'.5rem', background:'#f8fafc' }}>
          {filtered.map(team => {
            const checked = visibleTeams.has(team);
            return (
              <label key={team} style={{ display:'flex', alignItems:'center', gap:'.6rem', padding:'.55rem .5rem', background:'#fff', borderRadius:'.45rem', marginBottom:'.35rem', boxShadow:'0 1px 2px rgba(0,0,0,0.04)', fontSize:'.85rem', cursor:'pointer' }}>
                <input type="checkbox" checked={checked} onChange={() => toggleTeamVisibility(team)} />
                <span style={{ flex:1 }}>{team}</span>
              </label>
            );
          })}
          {filtered.length === 0 && <div style={{ fontSize:'.8rem', color:'#6b7280', fontStyle:'italic' }}>Geen teams gevonden</div>}
        </div>
        {isMobile && (
          <div style={{ display:'flex', gap:'.6rem', padding:'.7rem 0 .6rem' }}>
            <button onClick={onClose} style={{ flex:1, background:'#fff', color:'#057fa2', border:'1px solid #057fa2', borderRadius:'.5rem', padding:'.6rem .8rem', fontSize:'.8rem', fontWeight:600 }}>Sluiten</button>
            <TeamSaveControls userId={userId} selectedTeams={visibleTeams} onSaved={(t)=>{ setMsg(t); setTimeout(()=>setMsg(''), 3000); }} className="tq-filter__btn" />
          </div>
        )}
      </div>
    </div>
  );
}
